import { t } from '../../i18n';
import { useEffect, useState } from 'react';

const experience = [
  {
    role: t("Founder"),
    company: 'Virtuoz Solutions',
    period: t("Fév 2020 - Présent"),
    description: t("Développement de solutions web et mobiles, spécialisation en IA et automatisation des processus."),
  },
  {
    role: t("IT Department Manager"),
    company: 'Prim\'Holstein France',
    period: t("Oct 2020 - Présent"),
    description: t("Direction du département informatique, gestion d'équipe et pilotage de projets techniques."),
  },
  {
    role: t("Developer"),
    company: 'Prim\'Holstein France',
    period: t("Oct 2019 - Oct 2020"),
    description: t("Développement d'applications internes et modernisation des outils métier."),
  },
  {
    role: t("Research Engineer"),
    company: 'Orkeis',
    period: t("Sep 2017 - Oct 2019"),
    description: t("Ingénieur de recherche en développement logiciel et solutions innovantes."),
  },
  {
    role: t("Web & Mobile Developer"),
    company: 'Groupe MEDIS',
    period: t("Sep 2015 - Sep 2017"),
    description: t("Conception et développement d'applications web et mobiles pour le secteur médical."),
  },
  {
    role: t("Programmer Analyst"),
    company: 'Rapido',
    period: t("Sep 2014 - Août 2015"),
    description: t("Développement ERP en .Net (C#) et analyse des besoins métier."),
  },
];

const ExperienceSection = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="mb-20">
      {/* Section title */}
      <h2 className="section-title">
        <span>{t("Experience")}</span>
      </h2>

      <div className="space-y-8 xl:grid xl:grid-cols-2 xl:gap-x-12 xl:gap-y-8 xl:space-y-0">
        {experience.map((exp, index) => (
          <div
            key={index}
            className={`relative pl-6 transition-all duration-700 ease-out-expo ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${index * 150}ms` }}
          >
            {/* Timeline dot */}
            <div className="absolute left-0 top-2 w-2 h-2 rounded-full bg-primary shadow-glow" />

            {/* Timeline line */}
            {index < experience.length - 1 && (
              <div className="absolute left-[3px] top-5 bottom-0 w-px bg-gradient-to-b from-primary/30 to-transparent" style={{ height: 'calc(100% + 2rem)' }} />
            )}

            {/* Content */}
            <div className="flex items-start justify-between gap-4 mb-2">
              <div>
                <h3 className="text-foreground font-heading font-semibold">{exp.role}</h3>
                <p className="text-sm text-primary">{exp.company}</p>
              </div>
              <span className="text-xs text-muted font-heading tracking-wide">{exp.period}</span>
            </div>
            <p className="text-sm text-muted leading-relaxed">{exp.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExperienceSection;
